import { createSlice } from "@reduxjs/toolkit";
import { fetchOrderHistory } from "./order-history.thunks";
import { OrderHistoryState } from "./order-history.interface";
import { defaultApiState } from "../../common/constants/api-constants";
import { ActionStatus } from "../../common/constants/action-status";

export const orderHistoryInitialState: OrderHistoryState = defaultApiState;

/*----- CREATE STORE SLICE ------*/

export const orderHistorySlice = createSlice({
    name: "orderHistory",
    initialState: orderHistoryInitialState,
    reducers:{},
    extraReducers(builder){
      builder
      .addCase(fetchOrderHistory.pending, (state) =>{
        state.status = ActionStatus.loading;
        state.data = undefined;
      })
      .addCase(fetchOrderHistory.fulfilled, (state, action) =>{
        state.status = ActionStatus.succeeded;
        state.data = action.payload;
      })
      .addCase(fetchOrderHistory.rejected, (state, action) => {
        state.status = ActionStatus.failed;
        state.error = action.error.message || '';
      })
    }
  });

/*----- CREATE REDUCER ------*/

export const orderHistoryReducer = orderHistorySlice.reducer;